export default "__VITE_ASSET__cb7b6993__"